"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldsAddress = OfferFieldsAddress;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const AddressFields_1 = require("@src/components/modules/global/AddressFields");
const types_1 = require("@src/types");
const react_intl_1 = require("react-intl");
function OfferFieldsAddress({ form }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => prevValues[types_1.EOfferBasicInfoFormField.homeOffice] !== curValues[types_1.EOfferBasicInfoFormField.homeOffice], children: ({ getFieldValue }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Boolean(getFieldValue(types_1.EOfferBasicInfoFormField.homeOffice)) === false && ((0, jsx_runtime_1.jsx)(AddressFields_1.AddressFields, { baseName: types_1.EOfferBasicInfoFormField.address, form: form, countryLabel: intl.formatMessage({ id: 'admin.offer_form.country' }), formattedAddressLabel: intl.formatMessage({ id: 'admin.offer_form.address' }) })) })) }));
}
